export default "__VITE_ASSET__764ccd80__"